/*
 * What every page needs before Vue starts, and nothing else.
 *
 * This file used to pull in lodash, jQuery and popper.js on every page load -
 * none of which is used anywhere in the panel; the only jQuery in the source is
 * inside commented-out blocks - and then open a socket.io connection to the
 * broadcast server before a single screen had asked for one. Live tracking is
 * one screen out of thirty, so everyone else was paying for the library and
 * holding open a connection they never used.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let echoPromise = null;

/**
 * Connect to the broadcast server, once, when a screen actually needs it.
 *
 * Resolves to window.Echo. Safe to call repeatedly - the connection is made on
 * the first call and shared afterwards.
 */
export function ensureEcho() {
    if (window.Echo) {
        return Promise.resolve(window.Echo);
    }
    if (echoPromise) {
        return echoPromise;
    }

    echoPromise = Promise.all([
        import(/* webpackChunkName: "realtime" */ 'laravel-echo'),
        import(/* webpackChunkName: "realtime" */ 'socket.io-client'),
    ]).then(([echoModule, io]) => {
        const Echo = echoModule.default || echoModule;
        window.io = io.default || io;
        window.Echo = new Echo({
            broadcaster: 'socket.io',
            host: window.location.hostname + ':6001',
        });

        return window.Echo;
    });

    return echoPromise;
}
